import React, { useState } from 'react'
import { useAuth } from '../AuthContext'
import { glass } from '../glassStyles'

export default function PasswordChange() {
  const { authHeaders } = useAuth()
  const [form, setForm] = useState({ current: '', newPw: '', confirm: '' })
  const [saving, setSaving] = useState(false)
  const [message, setMessage] = useState(null) // { type: 'success'|'error', text }

  const handleSubmit = async () => {
    setMessage(null)
    if (!form.current || !form.newPw || !form.confirm) {
      setMessage({ type: 'error', text: 'すべての項目を入力してください' })
      return
    }
    if (form.newPw !== form.confirm) {
      setMessage({ type: 'error', text: '新しいパスワードと確認が一致しません' })
      return
    }
    if (form.newPw.length < 6) {
      setMessage({ type: 'error', text: 'パスワードは6文字以上にしてください' })
      return
    }

    setSaving(true)
    try {
      const res = await fetch('/api/me/password', {
        method: 'PUT',
        headers: { ...authHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ current_password: form.current, new_password: form.newPw }),
      })
      if (res.ok) {
        setMessage({ type: 'success', text: 'パスワードを変更しました。次回ログイン時から新しいパスワードをご利用ください。' })
        setForm({ current: '', newPw: '', confirm: '' })
      } else {
        const err = await res.json()
        setMessage({ type: 'error', text: err.detail || 'パスワード変更に失敗しました' })
      }
    } catch {
      setMessage({ type: 'error', text: 'パスワード変更に失敗しました' })
    } finally {
      setSaving(false)
    }
  }

  const inputStyle = {
    width: '100%', maxWidth: 400, padding: '10px 14px', borderRadius: 10,
    border: '1px solid rgba(255,255,255,0.12)', background: 'rgba(255,255,255,0.06)',
    color: '#fff', fontSize: 14, boxSizing: 'border-box',
  }

  return (
    <div>
      <h1 style={{ fontSize: 24, fontWeight: 700, color: 'rgba(255,255,255,0.9)', margin: '0 0 8px' }}>パスワード変更</h1>
      <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', margin: '0 0 24px' }}>
        現在のパスワードを入力して、新しいパスワードに変更します
      </p>

      {message && (
        <div style={{
          padding: '12px 18px', borderRadius: 10, marginBottom: 20, fontSize: 13,
          background: message.type === 'success' ? 'rgba(16,185,129,0.1)' : 'rgba(239,68,68,0.1)',
          border: `1px solid ${message.type === 'success' ? 'rgba(16,185,129,0.2)' : 'rgba(239,68,68,0.2)'}`,
          color: message.type === 'success' ? '#6ee7b7' : '#fca5a5',
        }}>
          {message.text}
        </div>
      )}

      <div style={{ ...glass.cardDark, padding: 32, maxWidth: 500 }}>
        <div style={{ marginBottom: 20 }}>
          <label style={{ fontSize: 13, color: 'rgba(255,255,255,0.6)', display: 'block', marginBottom: 6 }}>現在のパスワード</label>
          <input type="password" value={form.current} onChange={e => setForm({ ...form, current: e.target.value })} style={inputStyle} />
        </div>
        <div style={{ marginBottom: 20 }}>
          <label style={{ fontSize: 13, color: 'rgba(255,255,255,0.6)', display: 'block', marginBottom: 6 }}>新しいパスワード</label>
          <input type="password" value={form.newPw} onChange={e => setForm({ ...form, newPw: e.target.value })} style={inputStyle} />
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.3)', marginTop: 4 }}>6文字以上</div>
        </div>
        <div style={{ marginBottom: 24 }}>
          <label style={{ fontSize: 13, color: 'rgba(255,255,255,0.6)', display: 'block', marginBottom: 6 }}>新しいパスワード（確認）</label>
          <input type="password" value={form.confirm} onChange={e => setForm({ ...form, confirm: e.target.value })} style={inputStyle} />
        </div>
        <button onClick={handleSubmit} disabled={saving}
          style={{ ...glass.btn, ...glass.btnPrimary, padding: '12px 32px', fontSize: 14, opacity: saving ? 0.6 : 1 }}>
          {saving ? '変更中...' : 'パスワードを変更'}
        </button>
      </div>
    </div>
  )
}
